import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

export default function StatCard({ title, value, change, icon: Icon, trend }) {
  return (
    <motion.div 
      whileHover={{ y: -4 }}
      className="bg-slate-900 border border-slate-800 p-6 rounded-2xl"
    >
      <div className="flex justify-between items-start mb-4">
        <div className="p-3 bg-slate-800 rounded-xl">
          <SafeIcon icon={Icon} className="text-2xl text-indigo-400" />
        </div>
        <span className={`text-xs font-bold px-2 py-1 rounded-full ${
          trend === 'up' ? 'bg-emerald-500/10 text-emerald-400' : 'bg-rose-500/10 text-rose-400'
        }`}>
          {change}
        </span>
      </div>
      <p className="text-slate-400 text-sm font-medium mb-1">{title}</p>
      <h3 className="text-2xl font-bold text-white">{value}</h3>
    </motion.div>
  );
}